<template>
  <div>
    <Navigator :title="serviceMsg.serviceName" :routePath='"/"'></Navigator>
    <Tabbar :serviceId="serviceMsg.serviceId" @changeActive="changeActive"></Tabbar>
    <ServiceRate :score="score" :totalScoreNum="totalScoreNum" class="rate"></ServiceRate>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Tabbar from '../business/components/Tabbar';

export default {
  data() {
    return{
      BusinessList: [],
      pageList: [],
      pageIndex: 1,
      pageTotal: 0,
      disabled: false,
      typeId: 0,
      active: 0,
      serviceMsg: {},
      totalScoreNum: 0,// 总评价人数
      score: 0,//平均评分
    }
  },
  methods: {
    changeActive(typeId, serviceId) {
      this.totalScoreNum = 0;
      this.score = 0;
      this.serviceMsg.children.forEach((v)=>{
        if(v.serviceId == serviceId){
          this.totalScoreNum = v.totalScoreNum;
          this.score = v.totalScore/v.totalScoreNum;
        }
      })
      this.active = typeId;
      //路由跳转
      let query = this.$route.query;
      if(this.$route.params.serviceId != serviceId){
        query.bindQr = undefined;
      }
      switch (typeId) {
        case 11:
          this.$router.push({ path: `/business/businessList/recommend/${serviceId}`, query:query });
          break;
        case 12:
          this.$router.push({ path: `/business/businessList/meetingRoom/${serviceId}`, query:query });
          break;
        case 16:
          this.$router.push({ path: `/business/businessList/equipment/${serviceId}`, query:query });
          break;
        default:
      };
    },
  },
  components: {
    Tabbar
  },
  computed: {
    ...mapGetters(['parkServiceList']),
  },
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 2;
    });
    const path = this.$route.path.split('/')[2];
    if (path === 'recommend') {
      this.active = 11;
    } else if (path === 'meetingRoom') {
      this.active = 12;
    } else if (path === 'equipment') {
      this.active = 16;
    }
  }
}
</script>

<style lang="scss" scoped>
.rate{
  background-color: #F5F5F5;
  margin-bottom: .5rem;
  padding: .2rem .5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/List.vue